<script>
import authenticitysection from "./authenticitysection.vue";
import mentorshipsection from "./mentorshipsection.vue";
import chatbotsection from "./chatbotsection.vue";
import candidatesSection from "./candidatesSection.vue";
import facedetectsection from "./facedetectsection.vue";
import managementsection from "./managementsection.vue";
import midiasection from "./midiasection.vue";
import pricingsection from "./pricingsection.vue";
import statisticssection from "./statisticssection.vue";
import advantagessection from "./advantagessection.vue";
import videosection from "./videosection.vue";
export default {
  name: "Home",
  components: {
    authenticitysection,
    facedetectsection,
    mentorshipsection,
    chatbotsection,
    videosection,
    managementsection,
    midiasection,
    pricingsection,
    candidatesSection,
    statisticssection,
    advantagessection
  },
  data(){
    return {
      promotionalPrice: __PROMOTIONAL_PRICE__,
    };
  },
  mounted() {
    window.fbq('init', '258660308900348');
    window.fbq('track', 'PageView');
  },
  methods: {
    scrollTo($event) {
        const targetQuery = $event.target.getAttribute('href');
        const targetEl = document.querySelector(targetQuery);

        targetEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
        window.history.pushState(null, null, targetQuery);
    },
  },
};
</script>
<template>
  <div>
    <div
      id="greetings"
      class="row"
    >
      <div class="container">
        <section class="home-section">
          <div class="wrap-info wrap-info--7">
            <div class="credit-home">
              <h1>
                Uma iniciativa <a
                  href="https://appcivico.com/pt/"
                  target="_blank"
                  class="appcivico-home"
                >AppCívico</a>
              </h1>
            </div>
            <h1>
              De o primeiro passo para sua campanha eleitoral de 2022!
            </h1>
            <div class="wrap-info--text">
                   <p>
                      O Voto Legal é a plataforma pioneira no financiamento coletivo
                      de campanhas eleitorais e com maior média de doações entre todas
                      as plataformas! Além de tecnologia, acreditamos que é necessário
                      estratégia! Conte com a melhor plataforma e com a equipe mais
                      experiente do mercado para ajudar na sua pré campanha!
                    </p>
                    <p
                      v-if="699 != promotionalPrice"
                    >
                      Aproveite nossa promoção e garanta a sua licença de
                      pré-campanha+campanha, de <s>R$ 699,00</s> por
                      <strong>R$ {{ promotionalPrice }},00</strong>
                    </p>
                    <p v-else>
                      Garanta a sua licença única, para ser usada na pré-campanha e
                      também na campanha, por R$ 699,00.
                    </p>
                    <a
                      href="#email"
                      class="call-to-action"
                      @click.prevent="scrollTo"
                    >
                      Comprar
                    </a>
                  </div>

          </div>
        </section>
      </div>
    </div>
    <statisticssection />
    <mentorshipsection />
    <chatbotsection />
    <facedetectsection />
    <authenticitysection />
    <videosection />
    <advantagessection />
    <managementsection />
    <pricingsection />

    <midiasection />
    <candidates-section />

  </div>
</template>

<style lang="scss" scoped>
html {
  color: #ffffff;
}

img {
  width: 100%;
}

time,
s,
strong {
  font-weight: bold;
}

.container {
  height: 100%;
  max-width: 1200px;
}

#greetings {
  min-height: 50vh;

  background-image: url('../../img/header/bg-greetings-320w.jpg');
  background-position: 50% 150%;
  background-size: auto 500px;
  background-repeat: no-repeat;

  @media (min-width: 450px) {
    background-position: 100% 110%;
  }


  @media (min-width: 768px) {
    background-image: url('../../img/header/bg-greetings-768w.jpg');
    background-position: 84% 80%;
    background-size: auto 100%;
  }
  @media (min-width: 944px) {
    background-image: url('../../img/header/bg-greetings-1024w.jpg');
    background-position: top right;
  }
  @media (min-width: 1200px) {
    background-image: url('../../img/header/bg-greetings-1430w.jpg');
  }

  & p {
    max-width: 20em;

    margin-bottom: 1.5em;

    @media (min-width: 800px) {
      max-width: 28em;
    }

  }

  .wrap-info--text {
    padding-top: 0.5em;
    padding-bottom: 2.5rem;

    line-height: 1.5rem;

    color: #676767;
  }

  .innovare {
    width: 8rem;

    margin-top: 30px;

    opacity: 0.3;
    filter: grayscale(1);
  }
}


.home-section {
  padding-top: 7em;
  padding-bottom: 4em;

  overflow: hidden;

  @media (min-width: 450px) {
    padding-top: 8em;
    padding-bottom: 6em;
  }

  @media (min-width: 680px) {
    padding-top: 8em;
  }

  @media (min-width: 768px) {
    padding-top: 10em;
    padding-bottom: 5em;
  }

  @media (min-width: 991px) {
    padding-top: 13em;
    padding-bottom: 6em;
  }

  @media (min-width: 1199px) {
    padding-top: 15em;
    padding-bottom: 10em;
  }
  :after {
    clear: both;

    display: table;
  }

  .call-to-action {
    white-space: nowrap;
    position: relative;

    padding-top: 0.35em;
    padding-right: 0.5em;
    padding-bottom: 0.35em;
    padding-left: 0.5em;

    font-style: normal;
    font-weight: bold;
    font-size: 30px;

    text-transform: lowercase;

    cursor: pointer;

    color: #ffffff;

    background-color: #1e5b66;

    border-radius: 8px;

    &::before {
      color: rgb(51, 204, 102);

      content: '>';
    }

    &:hover {
      background-color: rgb(51, 204, 102);

      &::before {
        color: #1e5b66;
      }
    }
  }

  h1 {
    margin-bottom: 0.5em;

    line-height: 1;

    text-transform: none;

    color: rgb(51, 153, 153);
  }
}

h1 {
  display: block;

  width: 8em;

  font-weight: 700;
}

.credit-home {
  position: relative;

  z-index: 1;

  padding-bottom: 1.2em;
}

.credit-home h1 {
  display: inline;

  font-weight: 400;
  font-size: 15px;

  text-indent: 0.21em;
  vertical-align: middle;

  color: #6b6b6b;
}

.appcivico-home {
  display: inline-block;

  width: 115px;
  height: 19px;

  padding-left: 0.2em;

  overflow: hidden;

  text-indent: 110%;
  white-space: nowrap;

  background-image: url('../../img/header/appcivico-logo.svg');
  background-position: 40%;
  background-repeat: no-repeat;
}

</style>



// WEBPACK FOOTER //
// _source/javascript/components/home.vue